import { Routes, Route } from "react-router-dom";
import PrivateRoute from "./privateRoute";
import RestrictedRoute from "./restrictedRoute";
import Login from "../pages/Login";
import Home from '../pages/Home'
import Quantitative from "../pages/Home/quantitativo";
import Usuario from "../pages/Usuario";

import Internos from '../pages/Internos'
import InternalsByUnit from '../pages/Internos/internalsByUnit'
import InternosId from '../pages/Internos/internalDetails'
import InternalDetailsExternal from '../pages/Internos/internalDetailsExternal'
import Process from "../pages/Internos/process";
import Liberation from "../pages/Internos/liberation";
import SocialService from "../pages/Internos/socialService"
import Advogado from "../pages/Advogado"
import PesquisaProntuario from "../pages/PesquisaProntuario"
import PoliticaPrivacidade from "../pages/PoliticaPrivacidade"

import Psychology from "../pages/Saude/psychology"
import Nutrition from "../pages/Saude/nutrition"
import Odontology from "../pages/Saude/odontology"
import EvolucaoSaude from "../pages/Saude/evolucao"
import DemandaEspontanea from "../pages/Saude/demandaEspontanea"
import DoencasCronicas from "../pages/Saude/doencasCronicas"
import Tuberculose from "../pages/Saude/tuberculose"
import Hanseniase from "../pages/Saude/hanseniase"
import Testes from "../pages/Saude/testes"
import SaudeAdministrativo from "../pages/Saude/saudeAdministrativo"
import AssistenciaFarmaceutica from "../pages/Saude/assistenciaFarmaceutica"

import Admissao from "../pages/Saude/admisssao"
import Encaminhamento from "../pages/Saude/encaminhamento"
import Vacinacao from "../pages/Saude/vacinacao"
import Medicacao from "../pages/Saude/medicacao"
import ConsultaInterna from "../pages/Saude/consultaInterna"
import Exames from "../pages/Saude/exames"

import Unidades from '../pages/Unidades'
import UnidadeId from "../pages/Unidades/unitDetails";
 
import ChangeCell from "../pages/Transferencia/changeCell";
import CreateTransfer from "../pages/Transferencia/transferUnit";
import Schedule from "../pages/Agendamento/schedule";

import CadastroVisitante from "../pages/Visitantes/cadastro";
import CadastroVisitante2 from "../pages/Visitantes/cadastro2";
import ListVisitantes from "../pages/Visitantes/listVisitantes";
import ListVisitantesOutros from "../pages/Visitantes/listVisitantesOutros";
import VisitantesDetalhes from "../pages/Visitantes/visitantesDetalhes";

import SocialServiceAuthorizationVisite from "../pages/Autorizacoes/socialServiceAuthorizationVisite";
import DisciplineAuthorizationVisite from "../pages/Autorizacoes/disciplineAuthorizationVisite";
import CadastroAdvogado from "../pages/Advogado/cadastroAdvogado";
import Moviment from "../pages/Movimentacao";
import CreatMovement from "../pages/Movimentacao/createMovement";
import Sacolao from "../pages/Sacolao";
import AddVisitorOthers from "../pages/Visitantes/outrosVisitantes";

import PainelEducacao from "../pages/Educacao";
import Schools from "../pages/Educacao/schools";
import Teachers from "../pages/Educacao/teachers";
import Student from "../pages/Educacao/student";
import Course from "../pages/Educacao/courses";
import Discipline from "../pages/Educacao/disciplines";
import Class from "../pages/Educacao/class";
import Education from "../pages/Educacao/education";
import Seduc from "../pages/Educacao/painelSeduc";
import AcervoEducacao from "../pages/Educacao/acervo";

import Work from "../pages/Trabalho";
import Audiencias from "../pages/Audiencias";
import AgendamentosAdvogados from "../pages/AgendamentosAdvogados";
import Relatorios from "../pages/Relatorios";
import Training from "../pages/Treinamentos";
import Paineis from "../pages/Paineis";

function RoutesApp() {
  return (
    <Routes>
      {/* Rotas públicas */}
      <Route path="/login" element={<Login />} />
      <Route path="/cadastro-advogado" element={<CadastroAdvogado />} />
      <Route path="/cadastro-visitante" element={<CadastroVisitante />} />
      <Route path="/politica-de-privacidade" element={<PoliticaPrivacidade />} />

      {/* Rotas protegidas para usuários logados */}
      <Route element={<PrivateRoute />}>

        {/* Rotas protegidas por grupos/perfis */}
        <Route element={<RestrictedRoute />}>
          <Route path="/" element={<Home />} />
          <Route path="/quantitativo" element={<Quantitative />} />
          <Route path="/internos" element={<Internos />} />
          <Route path="/internos/unidade" element={<InternalsByUnit />} />
          <Route path="/internos/:internalId" element={<InternosId />} />
          <Route path="/internos/detalhes-externo/:internalId" element={<InternalDetailsExternal />} />
          <Route path="/processos" element={<Process />} />
          <Route path="/transferencia-cela" element={<ChangeCell />} />
          <Route path="/transferencia-unidade" element={<CreateTransfer />} />
          <Route path="/liberacao" element={<Liberation />} />
          <Route path="/liberacao/:id" element={<Liberation />} />
          <Route path="/servico-social" element={<SocialService />} />
          <Route path="/pesquisar-prontuario" element={<PesquisaProntuario />} />

          <Route path="/admissao" element={<Admissao />} />
          <Route path="/evolucao" element={<EvolucaoSaude />} />
          <Route path="/demanda-espontanea" element={<DemandaEspontanea />} />
          <Route path="/doencas-cronicas" element={<DoencasCronicas />} />
          <Route path="/tuberculose" element={<Tuberculose />} />
          <Route path="/hanseniase" element={<Hanseniase />} />
          <Route path="/testes" element={<Testes />} />
          <Route path="/saude-administrativo" element={<SaudeAdministrativo />} />
          <Route path="/assistencia-farmaceutica" element={<AssistenciaFarmaceutica />} />
          <Route path="/encaminhamento" element={<Encaminhamento />} />
          <Route path="/vacinacao" element={<Vacinacao />} />
          <Route path="/medicacao" element={<Medicacao />} />
          <Route path="/consulta-interna" element={<ConsultaInterna />} />
          <Route path="/exames" element={<Exames />} />
          <Route path="/nutricao" element={<Nutrition />} />

          <Route path="/psicologia" element={<Psychology />} />
          <Route path="/odontologia" element={<Odontology />} />
          <Route path="/movimentacao" element={<Moviment />} />
          <Route path="/cadastro-movimentacao" element={<CreatMovement />} />
          <Route path="/sacolao" element={<Sacolao />} />
          <Route path="/visitante" element={<AddVisitorOthers />} />
          <Route path="/cadastro-visitante-sistema" element={<CadastroVisitante2 />} />
          <Route path="/visitantes" element={<ListVisitantes />} />
          <Route path="/outros-visitantes" element={<ListVisitantesOutros />} />
          <Route path="/detalhes-visitantes/:visitorId" element={<VisitantesDetalhes />} />
          <Route path="/educacao" element={<Education />} />
          <Route path="/cadastros-edu" element={<PainelEducacao />} />
          <Route path="/escolas" element={<Schools />} />
          <Route path="/professores" element={<Teachers />} />
          <Route path="/alunos" element={<Student />} />
          <Route path="/cursos" element={<Course />} />
          <Route path="/disciplinas" element={<Discipline />} />
          <Route path="/turmas" element={<Class />} />
          <Route path="/painel-seduc" element={<Seduc />} />
          <Route path="/acervo-educacao" element={<AcervoEducacao />} />

          <Route path="/trabalho" element={<Work />} />
          <Route path="/audiencias" element={<Audiencias />} />
          <Route path="/agendamentos-advogados" element={<AgendamentosAdvogados />} />
          <Route path="/relatorios" element={<Relatorios />} />
          <Route path="/treinamentos" element={<Training />} />
          <Route path="/paineis" element={<Paineis />} />

          <Route path="/autorizacao-visita-servico-social" element={<SocialServiceAuthorizationVisite />} />
          <Route path="/autorizacao-visita-disciplina" element={<DisciplineAuthorizationVisite />} />

          <Route path="/unidades" element={<Unidades />} />
          <Route path="/unidades/:unitId" element={<UnidadeId />} />

          <Route path="/agendamento" element={<Schedule />} />

          {/* outras rotas */}
          <Route path="/advogado" element={<Advogado />} />
        </Route>

        {/* Rota disponível para todos os usuários logados */}
        <Route path="/usuario" element={<Usuario />} />
      </Route>
    </Routes>
  );
}

export default RoutesApp;
